import Error500 from "../../../pages/errors/500-error";

function ErrorComponent() {
  return <Error500 />;
}

export default ErrorComponent;
